export const isBaby = () => {
  return window.location.hostname.toLowerCase().indexOf('baby.zola.com') > -1;
};
